/**
 * Groups items by their `previewTenantId`, tenants in name order and items in
 * the order given.
 *
 * The tenant is a grouping attribute of a Project's preview target and nothing
 * else (ADR 0008 addendum): this is presentation over a list the caller can
 * already read, and it never decides what a caller may see.
 */
export function groupByPreviewTenant<T extends { previewTenantId: string }>(
  items: readonly T[],
): [string, T[]][] {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const group = groups.get(item.previewTenantId);
    if (group) {
      group.push(item);
    } else {
      groups.set(item.previewTenantId, [item]);
    }
  }
  return [...groups].sort(([left], [right]) => left.localeCompare(right));
}
